import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import IvoryLogo from "../../../assets/icons/IvoryLogo.svg"
import usePOST from "../../../hooks/usePOST";
import getToken from "../../../hooks/getToken";

const PaymentLogin = () => {
    const URL = process.env.REACT_APP_IVORY_API;
    const navigate = useNavigate();
    const [data, setData] = useState({
        username: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        phoneNumber: '',
        nationalId: '',
        companyName: '',
        companyNumber: '',
        subscription: false,
    });
    const [isLoggedIn, setIsLoggedIn] = useState(true);

    const { sendRequest, data: userData, isErr, isLoading } = usePOST();

    const createAccount = async (e) => {
        e.preventDefault();
        const requestBody = {
            email: data.email,
            password: data.password,
            password_confirmation: data.passwordConfirmation,
            'en[title]': data.companyName,
            national_id: data.nationalId,
            subscription: data.subscription ? 1 : 0
        };

        await sendRequest({
            link: `${URL}/en/register`,
            body: requestBody
        });
    };

    useEffect(() => {
        const seeToken = getToken();
        if (seeToken) {
            navigate('../way');
        } else {
            setIsLoggedIn(false);
            const timeout = setTimeout(() => {
                navigate('/login');
            }, 5000);

            return () => clearTimeout(timeout);
        }
    }, []);

    if (!isLoggedIn) {
        return (
            <div className="flex justify-center items-center">
                <p>
                    برجاء تسجيل الدخول اولا .
                </p>
            </div>
        )
    };

    return (
        <section className="border rounded-xl p-4">
            <form onSubmit={createAccount}>
                {/* inputs */}
                <div className="grid grid-cols-3 items-center gap-4 text-start max-lg:grid-cols-2 max-md:grid-cols-1 max-md:items-start max-md:flex-nowrap my-6">
                    {/* username */}
                    <div>
                        <label htmlFor="username" className="items-center gap-2 flex">
                            <span>
                                <img src={IvoryLogo} alt="ivory-logo" />
                            </span>
                            <span> اسم المستخدم</span>
                        </label>
                        <input
                            type="text"
                            id="username"
                            className="border rounded-md p-2 w-full mt-2 bg-[#F5F5F5] focus:ring-1 focus:ring-[#E5E5E5]"
                            value={data.username}
                            placeholder="أكتب اسم المستخدم هنا"
                            onChange={(e) => setData({ ...data, username: e.target.value })}
                            required
                            autoComplete=""
                        />
                    </div>

                    {/* email */}
                    <div>
                        <label htmlFor="email" className="items-center gap-2 flex">
                            <span>
                                <img src={IvoryLogo} alt="ivory-logo" />
                            </span>
                            <span>البريد الالكترونى</span>
                        </label>
                        <input
                            type="email"
                            id="email"
                            className="border rounded-md p-2 w-full mt-2 bg-[#F5F5F5] focus:ring-1 focus:ring-[#E5E5E5]"
                            value={data.email}
                            placeholder="أكتب البريد الالكتروني هنا"
                            onChange={(e) => setData({ ...data, email: e.target.value })}
                            required
                            autoComplete=""
                        />
                    </div>

                    {/* phone number */}
                    <div>
                        <label htmlFor="phone-number" className="items-center gap-2 flex">
                            <span>
                                <img src={IvoryLogo} alt="ivory-logo" />
                            </span>
                            <span>رقم الجوال</span>
                        </label>
                        <input
                            type="number"
                            id="phone-number"
                            className="border rounded-md p-2 w-full mt-2 bg-[#F5F5F5] focus:ring-1 focus:ring-[#E5E5E5]"
                            value={data.phoneNumber}
                            placeholder="أكتب رقم الجوال هنا"
                            onChange={(e) => setData({ ...data, phoneNumber: e.target.value })}
                            required
                            autoComplete=""
                        />
                    </div>

                    {/* password */}
                    <div>
                        <label htmlFor="password" className="items-center gap-2 flex">
                            <span>
                                <img src={IvoryLogo} alt="ivory-logo" />
                            </span>
                            <span>الرقم السري</span>
                        </label>
                        <input
                            type="password"
                            id="password"
                            className="border rounded-md p-2 w-full mt-2 bg-[#F5F5F5] focus:ring-1 focus:ring-[#E5E5E5]"
                            value={data.password}
                            placeholder="أكتب الرقم السري هنا "
                            onChange={(e) => setData({ ...data, password: e.target.value })}
                            required
                            autoComplete=""
                        />
                    </div>

                    {/* password confirmation */}
                    <div>
                        <label htmlFor="password-confirmation" className="items-center gap-2 flex">
                            <span>
                                <img src={IvoryLogo} alt="ivory-logo" />
                            </span>
                            <span> تأكيد الرقم السري</span>
                        </label>
                        <input
                            type="password"
                            id="password-confirmation"
                            className="border rounded-md p-2 w-full mt-2 bg-[#F5F5F5] focus:ring-1 focus:ring-[#E5E5E5]"
                            value={data.passwordConfirmation}
                            placeholder="أكتب تأكيد الرقم السري هنا"
                            onChange={(e) => setData({ ...data, passwordConfirmation: e.target.value })}
                            required
                            autoComplete=""
                        />
                    </div>

                    {/* company name */}
                    <div>
                        <label htmlFor="company-name" className="items-center gap-2 flex">
                            <span>
                                <img src={IvoryLogo} alt="ivory-logo" />
                            </span>
                            <span>اسم الشركة</span>
                        </label>
                        <input
                            type="text"
                            id="company-name"
                            className="border rounded-md p-2 w-full mt-2 bg-[#F5F5F5] focus:ring-1 focus:ring-[#E5E5E5]"
                            value={data.companyName}
                            placeholder="أكتب اسم الشركة هنا "
                            onChange={(e) => setData({ ...data, companyName: e.target.value })}
                            required
                            autoComplete=""
                        />
                    </div>

                    {/* company number */}
                    <div>
                        <label htmlFor="company-number" className="items-center gap-2 flex">
                            <span>
                                <img src={IvoryLogo} alt="ivory-logo" />
                            </span>
                            <span>رقم الشركة</span>
                        </label>
                        <input
                            type="number"
                            id="company-number"
                            className="border rounded-md p-2 w-full mt-2 bg-[#F5F5F5] focus:ring-1 focus:ring-[#E5E5E5]"
                            value={data.companyNumber}
                            placeholder="أكتب رقم الشركة هنا "
                            onChange={(e) => setData({ ...data, companyNumber: e.target.value })}
                            required
                            autoComplete=""
                        />
                    </div>

                    {/* national id */}
                    <div>
                        <label htmlFor="national-id" className="items-center gap-2 flex">
                            <span>
                                <img src={IvoryLogo} alt="ivory-logo" />
                            </span>
                            <span>رقم الهوية الوطنية</span>
                        </label>
                        <input
                            type="number"
                            id="national-id"
                            className="border rounded-md p-2 w-full mt-2 bg-[#F5F5F5] focus:ring-1 focus:ring-[#E5E5E5]"
                            value={data.nationalId}
                            placeholder="أكتب رقم الهويه الوطنية هنا"
                            onChange={(e) => setData({ ...data, nationalId: e.target.value })}
                            required
                            autoComplete=""
                        />
                    </div>
                </div>

                {/* privacy & news box*/}
                <div className="my-4">
                    <div className="flex items-center gap-2">
                        <input type="checkbox" id="privacy" />
                        <label htmlFor="privacy" className="flex items-center">
                            <span className="text-[#929292]">
                                الموافقة على {" "}
                            </span>
                            {" "}
                            <Link to={`/privacy`} className="text-primary-tw">
                                سياسة الخصوصية و الشروط والاحكام
                            </Link>
                        </label>
                    </div>
                    <div className="flex items-center gap-2">
                        <input type="checkbox" id="subscription"
                            value={data.subscription}
                            onChange={() => setData(prev => ({
                                ...prev,
                                subscription: !prev.subscription
                            }))} />
                        <label htmlFor="subscription" className="text-[#929292]">
                            اضافة البريد الالكترونى الى نشرة الاخبار
                        </label>
                    </div>
                </div>

                {/* buttons */}
                <div className="flex flex-col justify-center items-center">
                    <button
                        type="submit"
                        className="w-56 py-2 bg-primary-tw text-white my-2 rounded-lg">
                        انشاء حساب
                    </button>
                    <div className="flex items-center gap-2 mt-2">
                        <span>لديك حساب بالفعل؟</span>
                        <Link to={`/login`} className="text-secondary-tw underline underline-offset-1">
                            تسجيل الدخول
                        </Link>
                    </div>
                </div>
            </form>
        </section>
    );
};

export default PaymentLogin;